const en = {
  title: 'Your privacy choices',
  description: 'Essential storage keeps sign-in, security, and core pages working. Optional categories remain off until you choose them.',
  policy: 'Read cookie policy',
  acceptAll: 'Accept all',
  rejectOptional: 'Reject optional',
  manage: 'Manage choices',
  save: 'Save choices',
  back: 'Back',
  necessary: ['Essential', 'Always on', 'Required for security, sign-in, routing, and remembering this choice.'],
  preferences: ['Preferences', 'Optional', 'Stores your language preference on this device.'],
  analytics: ['Analytics', 'Optional', 'Fate Room does not currently run analytics or advertising cookies.'],
  diagnostics: ['Support diagnostics', 'Optional', 'Fate Room does not currently enable diagnostic cookies.'],
  note: 'You can change these choices any time from the cookie button.',
};

const sk = {
  title: 'Vaše voľby súkromia',
  description: 'Nevyhnutné úložisko zabezpečuje prihlásenie, bezpečnosť a fungovanie stránok. Voliteľné kategórie sú vypnuté, kým ich nezvolíte.',
  policy: 'Prečítať zásady cookies', acceptAll: 'Prijať všetko', rejectOptional: 'Odmietnuť voliteľné', manage: 'Spravovať voľby', save: 'Uložiť voľby', back: 'Späť',
  necessary: ['Nevyhnutné', 'Vždy zapnuté', 'Potrebné pre bezpečnosť, prihlásenie, navigáciu a zapamätanie voľby.'],
  preferences: ['Preferencie', 'Voliteľné', 'Uloží voľbu jazyka v tomto zariadení.'],
  analytics: ['Analytika', 'Voliteľné', 'Fate Room momentálne nepoužíva analytické ani reklamné cookies.'],
  diagnostics: ['Diagnostika podpory', 'Voliteľné', 'Fate Room momentálne nepovoľuje diagnostické cookies.'],
  note: 'Tieto voľby môžete kedykoľvek zmeniť tlačidlom cookies.',
};

const cs = {
  title: 'Vaše volby soukromí',
  description: 'Nezbytné úložiště zajišťuje přihlášení, bezpečnost a fungování stránek. Volitelné kategorie zůstávají vypnuté, dokud je nezvolíte.',
  policy: 'Přečíst zásady cookies', acceptAll: 'Přijmout vše', rejectOptional: 'Odmítnout volitelné', manage: 'Spravovat volby', save: 'Uložit volby', back: 'Zpět',
  necessary: ['Nezbytné', 'Vždy zapnuto', 'Nutné pro bezpečnost, přihlášení, navigaci a zapamatování této volby.'],
  preferences: ['Preference', 'Volitelné', 'Uloží volbu jazyka v tomto zařízení.'],
  analytics: ['Analytika', 'Volitelné', 'Fate Room nyní nepoužívá analytické ani reklamní cookies.'],
  diagnostics: ['Diagnostika podpory', 'Volitelné', 'Fate Room nyní nezapíná diagnostické cookies.'],
  note: 'Tyto volby můžete kdykoli změnit tlačítkem cookies.',
};

const es = {
  title: 'Tus opciones de privacidad',
  description: 'El almacenamiento esencial mantiene el inicio de sesión, la seguridad y las páginas principales. Las categorías opcionales permanecen desactivadas hasta que las elijas.',
  policy: 'Leer política de cookies', acceptAll: 'Aceptar todo', rejectOptional: 'Rechazar opcionales', manage: 'Gestionar opciones', save: 'Guardar opciones', back: 'Volver',
  necessary: ['Esenciales', 'Siempre activas', 'Necesarias para seguridad, inicio de sesión, navegación y recordar esta elección.'],
  preferences: ['Preferencias', 'Opcionales', 'Guarda tu idioma en este dispositivo.'],
  analytics: ['Analítica', 'Opcional', 'Fate Room no utiliza actualmente cookies analíticas ni publicitarias.'],
  diagnostics: ['Diagnóstico de soporte', 'Opcional', 'Fate Room no habilita actualmente cookies de diagnóstico.'],
  note: 'Puedes cambiar estas opciones en cualquier momento desde el botón de cookies.',
};

const pt = {
  title: 'As suas escolhas de privacidade',
  description: 'O armazenamento essencial mantém o início de sessão, a segurança e as páginas principais. As categorias opcionais ficam desativadas até que escolha.',
  policy: 'Ler política de cookies', acceptAll: 'Aceitar tudo', rejectOptional: 'Rejeitar opcionais', manage: 'Gerir escolhas', save: 'Guardar escolhas', back: 'Voltar',
  necessary: ['Essenciais', 'Sempre ativas', 'Necessárias para segurança, início de sessão, navegação e para memorizar esta escolha.'],
  preferences: ['Preferências', 'Opcionais', 'Guarda o idioma neste dispositivo.'],
  analytics: ['Analítica', 'Opcional', 'O Fate Room não utiliza atualmente cookies analíticos ou publicitários.'],
  diagnostics: ['Diagnóstico de apoio', 'Opcional', 'O Fate Room não ativa atualmente cookies de diagnóstico.'],
  note: 'Pode alterar estas escolhas a qualquer momento no botão de cookies.',
};

export const getCookieConsentCopy = (language) => ({ en, sk, cs, es, pt }[language] || en);
